import z from "zod";
import type { PagesConfig } from "~/domains/pageSchemas";
import { airportSchema } from "~/services/validation/airport";
import { hiddenInputSchema } from "~/services/validation/hiddenInput";
import {
  schemaOrEmptyString,
  schemaOrEmptyStringOptional,
} from "~/services/validation/schemaOrEmptyString";
import { stringOptionalSchema } from "~/services/validation/stringOptional";

export const fluggastrechteGrundvoraussetzungenPages = {
  grundvoraussetzungenStreitbeilegung: {
    stepId: "/grundvoraussetzungen/streitbeilegung",
    pageSchema: {
      streitbeilegung: z.enum(["yes", "no", "noSpecification"]),
    },
  },
  grundvoraussetzungenStreitbeilegungGruende: {
    stepId: "/grundvoraussetzungen/streitbeilegung-gruende",
    pageSchema: {
      streitbeilegungGruende: z.enum(["yes", "no", "noSpecification"]),
    },
  },
  grundvorraussetzungenProzessfaehig: {
    stepId: "/grundvoraussetzungen/prozessfaehig",
  },
  grundvoraussetzungenAusgleichszahlung: {
    stepId: "/grundvoraussetzungen/ausgleichszahlung",
  },
  grundvoraussetzungenDatenUebernahme: {
    stepId: "/grundvoraussetzungen/daten-uebernahme",
    pageSchema: {
      fluggesellschaft: hiddenInputSchema(schemaOrEmptyString(z.string())),
      startAirport: hiddenInputSchema(schemaOrEmptyString(airportSchema)),
      endAirport: hiddenInputSchema(schemaOrEmptyString(airportSchema)),
      entschaedigung: hiddenInputSchema(
        schemaOrEmptyString(stringOptionalSchema),
      ),
      bereich: hiddenInputSchema(stringOptionalSchema),
      ersatzflug: hiddenInputSchema(schemaOrEmptyString(stringOptionalSchema)),
      ankuendigung: hiddenInputSchema(
        schemaOrEmptyStringOptional(
          z.enum(["no", "until6Days", "between7And13Days", "moreThan13Days"]),
        ),
      ),
    },
  },
  grundvoraussetzungenAmtsgericht: {
    stepId: "/grundvoraussetzungen/amtsgericht",
  },
} satisfies PagesConfig;
